import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';
import { LuSettings } from 'react-icons/lu';

import { ApplicantRow } from './ApplicantRow';
import { DataSharingNotifications } from './DataSharingNotifications';
import { BankCreditRequestFormSection } from '../BankCreditRequestFormSection';

type Props = {
    lead: SchemaLoanRequestResolver_Get;
};

export const DataSharing: React.FC<Props> = ({ lead }) => {
    const { t } = useTranslation();
    const hasTwoApplicants = lead.antragsteller2 != null;
    return (
        <BankCreditRequestFormSection
            title={t('BANK_CREDIT_REQUEST.DATA_SHARING.TITLE')}
            headerNotification={<DataSharingNotifications hasTwoApplicants={hasTwoApplicants} />}
            icon={<LuSettings className="size-4" />}
            testId="data-sharing"
        >
            <div className="flex flex-col gap-4 border-t border-grey-light pt-3">
                <ApplicantRow applicant={1} lead={lead} />
                {hasTwoApplicants && <ApplicantRow applicant={2} lead={lead} />}
            </div>
        </BankCreditRequestFormSection>
    );
};
